import * as React from "react";
import { formatAsBrowserTime, adjustFormat } from "util/DateTime";
const BrowserTime = ({ dateTime: dateTimeProp = void 0, format = "default" }) => {
  const dateTime = dateTimeProp != null ? dateTimeProp : /* @__PURE__ */ new Date();
  const dateTimeString = adjustFormat(dateTime, "internal");
  const timeInBrowserTimeZone = formatAsBrowserTime(dateTime, format);
  return /* @__PURE__ */ React.createElement("time", { dateTime: dateTimeString, title: dateTimeString }, timeInBrowserTimeZone);
};
export default BrowserTime;
